import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/application/src/app/error.tsx");
